import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient, ConvertParamsToFormData } from "~/utils";

import {
  PreviewWithFileType,
  RawDraftContentState,
  MemberInsightPostsMutateType,
} from "~/domains";

type RequestDataType = {
  id: string;
  body: {
    content: RawDraftContentState;
    shareable: boolean;
    jobCategoryPhaseId: string | undefined;
    attachFiles: PreviewWithFileType[];
    quotePostId?: string;
  };
};

const request = ({ id, body }: RequestDataType) => {
  const formData = ConvertParamsToFormData({ insightPost: body });
  return new ApiClient()
    .put<MemberInsightPostsMutateType>(
      `/api/members/insight_posts/${id}`,
      formData,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisMembersInsightPostsUpdate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  MemberInsightPostsMutateType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
